// / STEP 1 - Include Dependencies
// Include react
import React from "react";


// Include the react-fusioncharts component
import ReactFC from "react-fusioncharts";

// Include the fusioncharts library
import FusionCharts from "fusioncharts";

// Include the chart type
import Chart from "fusioncharts/fusioncharts.charts";

// Include the theme as fusion
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Chart, FusionTheme);


const ChartComponent = ({data})=>{
  const chartConfigs = {
  type: "pie3d", // The chart type
  width: "100%", // Width of the chart
  height: "400", // Height of the chart
  dataFormat: "json", // Data type
  dataSource: {
    // Chart Configuration
    chart: {
      caption:"Languages",
      theme:"fusion",
      // to remove decimals from percentage
      decimals:0,
      // size of pie
      pieRadius:'45%',
      paletteColors:'#f0db4f'
    },
    // Chart Data
    // data:data(es6 shorthand)
    data,
  }
};

  return <ReactFC {...chartConfigs}></ReactFC>
}




export default ChartComponent;